import { createSelector } from 'reselect'

import { RequestStatus } from 'clickNgo/configs/service/common'

import { selectLandingState } from './selectLandingState'

export const selectLandingIsSearchLoading = createSelector(
  [selectLandingState],
  ({ partnerSearchStatus }) => {
    return partnerSearchStatus === RequestStatus.PENDING
  }
)
